import request from "@/utils/request"

// 获取token
export function getToken(){
    return request({
        url:'/user/passport/single/point/login',
        method:'GET',
        params:{
            userId:'1534774698493153281'
        }
    })
}

// 设备在线统计
export function onlineStat(zoneId){
    return request({
        url:'/device-search/view/devices/zone/'+zoneId+'/productType/onlineRate',
        method:'GET',
    })
}

//获取设备列表
export function equipList(params){
    return request({
    //   url : "/device-search/view/devices/customer/"+params.customerId,
      url : "/device-search/devices/product/page",
      method:'GET',
      params
    })
}


// 查询实时数据
export function realData(id){
    return request({
        url:'/device-search/view/data/'+id,
        method:'GET',
        // params
    })
}

// 查询历史数据
export function historyData(params){
    return request({
        url:'/device-search/history/view/data/'+params.deviceId+'/aggregation',
        method:'GET',
        params
    })
}

// 获取杀虫数量(天)
export function killWormNum(data) {
    return request({
        url: '/product/productDevice/getDeviceHistoryData',
        method: 'POST',
        data
    })
}

// 获取杀虫数量汇总
export function killWormNumTotal(data) {
    return request({
        url: '/product/productDevice/getDeviceElementTotal',
        method: 'POST',
        data
    })
}

// 获取虫情汇总数据（识别）
export function insectData(params){
    return request({
      url : "/product/productDevice/getInsectGatherData",
      method:'GET',
      params
    })
}

// 获取虫情历史数据（识别）---所有数据+环比
export function insectHistory(data){
    return request({
      url : "/product/productDevice/getInsectHistoryData",
      method:'POST',
      data
    })
}

// 虫情识别数据（每天识别数量统计）
export function insectStatistics(data){
    return request({
      url : "/product/productDevice/statisticsInsectHistoryData",
      method:'POST',
      data
    })
}


// 获取图片（虫情监测）
export function getPhoto(data){
    return request({
      url : "/device-search/view/data/getDevicePicPageData",
      method:'POST',
      data
    })
}

// 监控设备在线率统计
export function liveOnlineRate(params){
    return request({
      url : "/device-search/view/devices/productType/"+params.typeId+ "/zone/" + params.zoneId+"/onlineRate",
      method:'GET',
    })
}

// 获取视频播放地址
export function liveAddress(params){
    return request({
      url : "/device-search/view/devices/"+params.deviceId+"/live",
      method:'GET',
      params
    })
}

/**
 * 获取播放凭证
 */
export function getDeviceLiveAddressTokenApi() {
    return request({
        url: `/product/productDevice/seedling/token`,
        method: 'get',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
}
